<template>
    <div class="memberedit">
        <div class="area">
            <p class="title">基本信息修改</p>
            <!-- form表单元素 -->
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" :rules="rules" status-icon
                label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户名：" prop="user" size="mini">
                    <el-input type="text" :disabled="true" v-model="dynamicValidateForm.user" placeholder="汉字/字母/数字及其组合均可"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="email" size="mini">
                    <el-input type="email" v-model="dynamicValidateForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="专业方向：" prop="specialty" size="mini">
                    <el-input type="text" v-model="dynamicValidateForm.specialty" placeholder="正确填写，更好为你服务"></el-input>
                </el-form-item>
                <el-form-item label="单位名/姓名:" prop="name" size="mini">
                    <el-input type="text" v-model="dynamicValidateForm.name" placeholder="单位名称或您下姓名、 昵称均可"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="phone" size="mini">
                    <el-input type="text" v-model.number="dynamicValidateForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="QQ号码：" prop="qq" size="mini">
                    <el-input type="text" v-model.number="dynamicValidateForm.qq" placeholder="填写常用QQ方便联系"></el-input>
                </el-form-item>

                <el-form-item>
                    <span class="btn" @click="reset_user_data">重置</span>
                    <span class="btn" @click="submitForm('dynamicValidateForm')">
                        <i v-if="request">修改信息</i>
                        <i class="el-icon-loading lod" v-else></i>
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <div class="area">
            <p class="title">密码修改</p>
            <div>
                <el-form :model="ruleForm" status-icon :rules="rules2" ref="ruleForm" label-width="100px"
                    class="demo-ruleForm">
                    <el-form-item label="旧密码" prop="pwd" size="mini">
                        <el-input type="password" v-model="ruleForm.pwd" autocomplete="off" placeholder="请输入旧密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="pass" size="mini">
                        <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass" size="mini">
                        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请确认密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span class="btn" @click="$refs['ruleForm'].resetFields()">重置</span>
                        <span class="btn" type="primary" @click="submitForm('ruleForm')">修改密码</span>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    // 验证密码规则
    function test(s) {
        if (/^(\d)\1+$/.test(s)) return false; // 全一样
        var str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) - pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺增
        str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) + pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺减
        return true;
    }

        export default {
            data() {
                // 检查旧密码是否填写
                var validatepwd = (rule, value, callback) => {
                    if (value === '') {
                            callback(new Error('请输入旧密码'));
                        } else {
                            callback();
                        };
                };
                // 验证密码
                var validatePass = (rule, value, callback) => {
                    if (value === '') {
                            callback(new Error('请输入新密码'));
                        } else if (!test(value)) {
                            callback(new Error('密码过于简单'));
                        } else {
                            callback();
                        };
                };
                var validatePass2 = (rule, value, callback) => {
                    if (value === '') {
                            callback(new Error('请确认密码'));
                        } else if (value != this.ruleForm.pass) {
                            callback(new Error('两次输入密码不一致!'));
                        } else {
                            callback();
                        };
                };
                return {
                    request: true,
                    // 表单数据
                    dynamicValidateForm: {
                        user: '',
                        email: '',
                        specialty: '',
                        name: '',
                        phone: '',
                        qq: '',
                    },
                    ruleForm: {
                        pwd: '',
                        pass: '',
                        checkPass: '',
                    },
                    rules: {
                        email: [
                            { required: true, type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                        ],
                        specialty: [
                            { min: 2, max: 20, message: '专业方向长度在2到20个字符', trigger: 'blur' },
                            { required: true, message: '专业方向不能为空', trigger: 'blur' }
                        ]
                    },
                    rules2: {
                        pwd: [
                            { required: true, validator: validatepwd, trigger: 'blur' },
                        ],
                        pass: [
                            { min: 8, max: 16, message: '密码长度在8到16个字符', trigger: 'blur' },
                            { required: true, validator: validatePass, trigger: 'blur' },
                        ],
                        checkPass: [
                            { min: 8, max: 16, message: '密码长度在8到16个字符', trigger: 'blur' },
                            { required: true, validator: validatePass2, trigger: 'blur' },
                        ],
                    }
                    };
            },
            created () {
                this.request_user_data()
            },
            methods: {
                // 请求基本信息
                request_user_data () {
                    this.$http.getUserInfo().then(response => {
                    if (response.code===200) {
                        this.dynamicValidateForm.user = response.data.login_name;
                        this.dynamicValidateForm.email = response.data.email;
                        this.dynamicValidateForm.specialty = response.data.major;
                        this.dynamicValidateForm.name = response.data.user_name;
                        this.dynamicValidateForm.phone = response.data.phone;
                        this.dynamicValidateForm.qq = response.data.qq;
                    }
                }).catch(err => {
                    this.$message.error('获取失败');
                })
                },
                // 提交表单
                submitForm(formName) {
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                if ('dynamicValidateForm' == formName) {
                                // 修改资料
                                    let param = new URLSearchParams();
                                    param.append("email", this.dynamicValidateForm.email);
                                    param.append("major", this.dynamicValidateForm.specialty);
                                    param.append("user_name", this.dynamicValidateForm.name);
                                    param.append("phone", this.dynamicValidateForm.phone);
                                    param.append("qq", this.dynamicValidateForm.qq);
                                    this.$http.postChangeInfo(param).then(response => {
                                        if (response.code == 200) {
                                            this.$message({
                                                message: '基本信息修改成功',
                                                type: 'success'
                                            });
                                        }else{
                                            this.$message({
                                                message: response.msg,
                                                type: 'warning'
                                            });
                                        }
                                    }).catch(err => {
                                        this.$message.error('发生错误');
                                    });
                                }else if ('ruleForm' == formName) {
                                // 修改密码
                                    let param = new URLSearchParams();
                                    param.append("old_pwd", this.ruleForm.pwd);
                                    param.append("new_pwd", this.ruleForm.pass);
                                    this.$http.postChangePwd(param).then(response => {
                                        if (response.code == 200) {
                                            this.$message({
                                                message: '密码修改成功',
                                                type: 'success'
                                            });
                                        }else{
                                            this.$message({
                                                message: response.msg,
                                                type: 'warning'
                                            });
                                        }
                                    }).catch(err => {
                                        this.$message.error('发生错误');
                                    });
                                }
                            } else {
                                return false;
                            }
                        });
                },

                // 清除用户信息
                reset_user_data () {
                    this.dynamicValidateForm.email = "";
                    this.dynamicValidateForm.specialty = "";
                    this.dynamicValidateForm.name = "";
                    this.dynamicValidateForm.phone = "";
                    this.dynamicValidateForm.qq = "";
                }
            }
        }
</script>
<style scoped>
    .memberedit {
        width: 400px;
        margin: 0 auto;
    }

    .area {
        margin-top: 15px;
    }

    .title {
        color: red;
        font-size: 16px;
    }
    .demo-ruleForm {
        padding-top: 20px;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        color: white;
        border: 0;
        background-color: #A7231E;
        font-weight: bold;
        padding: 5px 10px;
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
        background-color: rgb(207, 50, 44);
    }
</style>